import React, { useState, useEffect } from "react";
import AddIcon from "@material-ui/icons/Add";
import {
  BusinessCustomer,
  EditIcon,
  EndUsers,
  LeadVititor,
  SoftwareReleaseDeleteIcon,
  SoftwareReleaseEyeIcon,
  SortIcon,
} from "../../LeftNav/SvgIcons";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Checkbox,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import MarketingGridModal from "./MarketingGridModal";
import { OpenInNew } from "@material-ui/icons";
import { TooltipDescription } from "../../../../components/common/Modal/AssetsModals";
import TagsOverlay from "../ConversationsRevamp/TagsOverlay";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: "15px",
  },
  gridTopNav: {
    padding: "10px 0 10px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // minHeight: "30px",
  },
  selectedItems: {
    textAlign: "right",
    color: "#8D99A5",
    fontSize: "14px",
    fontWeight: "400",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  deleteItems: {
    display: "flex",
    alignItems: "center",
  },
  gridHeaderInner: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "4px",
    paddingBottom: "4px",
    textAlign: "left",
  },
  gridHeaderInnerCenter: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "4px",
    paddingBottom: "4px",
    textAlign: "center",
  },
  gridBodyInnerCenter: {
    textAlign: "center",
  },
  gridHeader: {
    background: "#E5F2FF",
    borderRadius: "6px",
  },
  gridHeaderRow: {
    borderRadius: "6px",
  },
  checkBoxFont: {
    fontSize: "22px",
  },
  gridBodyInner: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    padding: "15px 10px",
  },
  gridBodyInnerEmail: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    padding: "15px 10px",
    textTransform: "capitalize",
  },
  lastChildRadius: {
    borderRadius: "0px 6px 6px 0px",
    textAlign: "center",
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "12px",
    paddingBottom: "9px",
    paddingRight: "70px",
  },
  editButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  iconButton: {
    textAlign: "center",
    "&:hover": {
      backgroundColor: "unset",
    },
  },
}));

const PastCompaignsGrid = ({
  campaignsData,
  order,
  onOrderBy,
  setOpenCampPreviewModal,
  setOpenDeleteFilesOverlay,
  isMailResend,
  setIsMailResend,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [openGridModal, setOpenGridModal] = useState(null);

  return (
    <Paper className={classes.paper}>
      <Table>
        <TableHead className={classes.gridHeader}>
          <TableRow className={classes.gridHeaderRow}>
            <TableCell className={classes.gridHeaderInner}>
              Subject
              <TableSortLabel
                active={order.key === "Subject"}
                direction={order.val === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    key: "Subject",
                    val: order.val === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Type
              <TableSortLabel
                active={order.key === "Type"}
                direction={order.val === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    key: "Type",
                    val: order.val === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Created At
              <TableSortLabel
                active={order.key === "CreatedDate"}
                direction={order.val === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    key: "CreatedDate",
                    val: order.val === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.lastChildRadius}>Group(s)</TableCell>
            <TableCell className={classes.lastChildRadius}>
              Quick Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {campaignsData?.length > 0 &&
            campaignsData?.map((item, index) => {
              return (
                <TableRow key={index} className='gridBodyRow'>
                  <TableCell className={classes.gridBodyInnerEmail}>
                    <TooltipDescription
                      title={
                        <TagsOverlay
                          title='Campaign Subject'
                          noChipText='No Subject Added'
                          tags={[]}
                          text={item.subject}
                        />
                      }
                      placement={"bottom"}>
                      <span>
                        {item?.subject?.length <= 45
                          ? item.subject
                          : `${item?.subject?.substring(0, 45)}...`}
                      </span>
                    </TooltipDescription>
                  </TableCell>
                  <TableCell className={classes.gridBodyInnerEmail}>
                    {item.type ? item.type : "--"}
                  </TableCell>
                  <TableCell className={classes.gridBodyInner}>
                    {moment(item.createdDate).format("MMMM DD, YYYY")}
                  </TableCell>
                  <TableCell className={classes.editButton}>
                    {item?.campaignEndUsers?.length ? (
                      <Tooltip title={"End Users"} placement='top'>
                        <IconButton
                          onClick={() => {
                            setOpenGridModal({
                              title: "End Users",
                              data: item.campaignEndUsers,
                            });
                          }}>
                          <EndUsers className='releaseIcon' />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {item?.businessUsers?.length ? (
                      <Tooltip title={"Business Users"} placement='top'>
                        <IconButton
                          onClick={() => {
                            setOpenGridModal({
                              title: "Business Users",
                              data: item.businessUsers,
                            });
                          }}>
                          <BusinessCustomer className='releaseIcon' />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {item?.campaignLeadUsers?.length ? (
                      <Tooltip title={"Lead Users"} placement='top'>
                        <IconButton
                          onClick={() => {
                            setOpenGridModal({
                              title: "Lead Users",
                              data: item.campaignLeadUsers,
                            });
                          }}>
                          <LeadVititor className='releaseIcon' />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </TableCell>
                  <TableCell className={classes.iconButton}>
                    <IconButton
                      className={classes.iconButton}
                      onClick={() => {
                        setOpenCampPreviewModal(item);
                      }}>
                      <SoftwareReleaseEyeIcon />
                    </IconButton>
                    <IconButton
                      className={classes.iconButton}
                      onClick={() => {
                        setIsMailResend(item);
                      }}>
                      <OpenInNew style={{ color: "rgb(54, 153, 255)" }} />
                    </IconButton>
                    <IconButton
                      className={classes.iconButton}
                      onClick={() => setOpenDeleteFilesOverlay(item?.id)}>
                      <SoftwareReleaseDeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          {!campaignsData?.length ? (
            <TableRow key='0' className='gridBodyRow'>
              <TableCell
                colSpan='6'
                className={classes.gridBodyInner}
                style={{ textAlign: "center" }}>
                <span className='emptyGridText'>Uh Oh! No Campaign Found.</span>
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
      {openGridModal?.title ? (
        <MarketingGridModal
          open={openGridModal?.title}
          setOpen={setOpenGridModal}
          data={openGridModal}
        />
      ) : null}
    </Paper>
  );
};

export default PastCompaignsGrid;
